import React, { useEffect, useMemo } from "react";
import * as THREE from "three";

/**
 * Renders Gaussian centers as conventional colored point primitives
 * for comparison with the splat representation.
 */
export default function GaussianPoints({ data, pointSize = 0.025 }) {
  const geometry = useMemo(() => {
    if (!data) {
      return null;
    }

    const geometry = new THREE.BufferGeometry();

    geometry.setAttribute(
      "position",
      new THREE.BufferAttribute(data.positions, 3),
    );

    geometry.setAttribute("color", new THREE.BufferAttribute(data.colors, 3));

    geometry.computeBoundingSphere();

    return geometry;
  }, [data]);

  useEffect(() => {
    return () => {
      geometry?.dispose();
    };
  }, [geometry]);

  if (!geometry) {
    return null;
  }

  return (
    <points geometry={geometry}>
      <pointsMaterial size={pointSize} sizeAttenuation vertexColors />
    </points>
  );
}
